// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__BuildingsAndLocationsPage__buildingWizardTitle{--GW-FONT-WEIGHT-SEMI-BOLD:normal}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-renewal-cp-react/pages/BuildingsAndLocations/BuildingsAndLocationsPage.module.scss"],"names":[],"mappings":"AAAA,qDACI,iCAAA","sourcesContent":[".buildingWizardTitle {\n    --GW-FONT-WEIGHT-SEMI-BOLD: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buildingWizardTitle": "app__BuildingsAndLocationsPage__buildingWizardTitle"
};
export default ___CSS_LOADER_EXPORT___;
